import * as yup from "yup";

export const validationSchema = yup.object().shape({
  courseTitle: yup.string().required("Title is not valid."),
  courseShortname: yup.string().required("Short name is not valid."),
  courseDate: yup.string().required("Pick a Start Date is not valid."),
});
